import App from "theme/base/App"
import React from "react"

import "./theme.scss"
import "components/ShoppableImage/ShoppableImage"
import shop from "shop/shop"

// SPALTEN LISTENANSICHT
import orthoFieldConfig from "./ortho-product-list.json"
import { useLocation } from 'react-router-dom'
// SPALTEN PRODUKTDETAILANSICHT
import orthoFieldConfigProductDetails from "./ortho-product-details.json"
import orthoFieldConfigTranslation from "./ortho-field-config-translation.json"

import cmsStore from "stores/cmsStore"
import { setDefaultCurrency } from "components/Price/Price"
import productStore from "stores/productStore"
import EmptyLayout from "layout/EmptyLayout";
import BudgetAccountSelection from "components/Budget/BudgetAccountSelection"
import CurrentCustomerHeader from "components/Header/CurrentCustomerHeader";
import RouteWithLogin from "layout/RouteWithLogin";
import { date } from "notie"

productStore.baseSearchUrl = "data/v2/search" // CONFIG NEW SEARCH URL


setDefaultCurrency( {currencySymbol: "EUR"} )

const getDerivedFieldname = ( value ) => {
	return orthoFieldConfigTranslation[value] || value
}

shop.config.MIN_ORDER_PENALTY_VALUE = 1
shop.config.budgetManager = true
shop.config.disable_handId_redirect = true

const mapCustomFieldData = ( data ) => {

	const configByCategoryId = {}
// DEFAULT CONFIG
	data.push( {
		"id": 2,
		"mapid": "DEFAULT",

	}, )

	data.push({
		
  

	})

	data.map( categoryConfig => {
		let columns = []

		categoryConfig.columns = columns
		configByCategoryId[categoryConfig.mapid] = categoryConfig
	} )

	return configByCategoryId
}

cmsStore.config.orthoFieldConfigByCategory = mapCustomFieldData( orthoFieldConfig )
cmsStore.config.orthoFieldProductDetailConfigByCategory = mapCustomFieldData( orthoFieldConfigProductDetails )
cmsStore.config.hideAddtionalCheckoutMetaForPowerUsers = true

// cmsStore.config.filter_defaults.view = "list"

class AppOrtho extends React.Component {

	componentWillMount() {
		cmsStore.config.filter_defaults = {
			sort: "sort"
		}
		cmsStore.config.standards = {
			sort: "sort"
		}
	}

	render() {
		return <App
			before={<div className="bg-dark ph2 pv2">
				{/*<CurrentCustomerHeader/>*/}
				</div>}
		>
			{/*<RouteWithLogin layout={EmptyLayout} path={"/login/accounts/:customerId?"} component={BudgetAccountSelection}/>
			<RouteWithLogin layout={EmptyLayout} path={"/account/budgets"} component={BudgetAccountSelection}/>*/}
		</App>
	}
}

export default AppOrtho



// WEBPACK FOOTER //
// ./src/theme/lindt/App.js